export default {"src":"/_next/static/media/college7.f4c56e37.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};